var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.canResetPaymentPassword ? _c('BButton', {
    attrs: {
      "variant": "outline-danger",
      "size": _vm.inList ? 'sm' : ''
    },
    on: {
      "click": _vm.handleResetPaymentPassword
    }
  }, [_c('span', {}, [_vm._v(_vm._s(_vm.$t("myAccount.paymentPassword.reset".concat(_vm.inList ? 'Short' : ''))))])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }